import { useAtomValue } from 'jotai';
import { FC } from 'react';
import { $CampaignBanner } from 'shared/atoms/common/campaign-banner';
import { $ShowBrandGuidanceInNav } from '~/utils/libra/brand-guidance';
import { $BrandBanner } from 'shared/atoms';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';

export const PreloadCampaignBanner: FC = () => {
  const showBrandGuidanceInNav = useAtomValue($ShowBrandGuidanceInNav);

  const campaign = useAtomValue($CampaignBanner)[0];
  const brandBanner = useAtomValue($BrandBanner);

  if (showBrandGuidanceInNav) {
    return (
      <DynamicHead>
        <link rel="preload" as="image" href={brandBanner.bannerUrl} />
      </DynamicHead>
    );
  }

  if (!campaign) {
    return null;
  }

  return (
    <DynamicHead>
      <link rel="preload" as="image" href={campaign.bannerUrl} />
    </DynamicHead>
  );
};
